module.exports = __webpack_public_path__ + "fa4fb9b3f7fb77adcdd5fc50542de1dc.svg";